export function dateWithoutTime(date) {
  date.setHours(0, 0, 0, 0)
  return date
}
